import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import { SPACING_REGULAR } from '../../constant/spacing';

interface Props {
  hasModificationRequest: boolean;
  className?: string;
}

const ModificationDescription = ({ hasModificationRequest, className }: ClassAttributes<HTMLElement> & Props) => {
  const messageType = hasModificationRequest ? 'requested' : 'waiting';

  return (
    <Fragment>
      <Message className={className}>
        <FormattedMessage id={`show_creation_page.description.modification_${messageType}`} />
      </Message>
      {messageType === 'requested' ? (
        <Typography>
          <FormattedHTMLMessage id="show_creation_page.modification_request_feedback" />
        </Typography>
      ) : null}
    </Fragment>
  );
};

const Message = styled(Typography)({
  marginBottom: SPACING_REGULAR,
});

export default ModificationDescription;
